import * as React from 'react';
import { connect } from 'react-redux';
import { EModalType, IToolsState, DOMHelper } from '../helpers';
import ControlConfigContainer from './control-config';
import AddComponentContainer from './add-component';
import ActionConfigContainer from './action-config';
import DecisionConfigContainer from './decision-config';
import OutputsDialogContainer from './outputs-dialog';
import JourneyTypeContainer from './journey-type-config';
import SummaryDialogContainer from './summary-dialog';
import SubmissionConfigContainer from './submission-config';
import SaveAsContainer from './save-as';
import SharedJourneyConfigContainer from './shared-journey-config';
import RedirectConfigContainer from './redirect-config';
import ControlBlockConfigContainer from './control-block-config';
import AuthenticationWarningContainer from './authentication-warning';
import LoopConfigContainer from './loop-config';
import store from '../store/store';
import types from '../store/types';
import { DialogType } from 'office-ui-fabric-react';
import { Cascade } from '../components/layout/cascade';

class CascadeContainer extends React.Component<any, any, any> {
    // constructor(props: any) {
    //     super(props);
    //     this.state = {
    //         showBlockContent: false
    //     };
    //     this.changeShowBlockContent = this.changeShowBlockContent.bind(this);

    // }
    // changeShowBlockContent() {
    //     const newShowBlockContent = this.props.showBlockContent;
    //     this.props.changeShowBlockContent(newShowBlockContent);
    // }

    dismissDialog = () => {

        let { openModal } = this.props.state.modal;
        let { outputs } = this.props;

        store.dispatch({ type: types.TOGGLE_DIALOG, openModal: EModalType.None });

        if (openModal === EModalType.GlobalOutputs)
            store.dispatch({ type: types.SET_GLOBAL_OUTPUTS_STATE, outputs: outputs });
    }

    dismissErrorMessage = () => {
        store.dispatch({
            type: types.SET_ERROR_MESSAGE_DISMISSED,
            errorMessageDismissed: true
        });

    }

    componentDidMount = () => {

        // let toolsState: IToolsState = store.getState().toolsState;
        // let journeyId = toolsState.journeyId;

        // if (journeyId === "") {
        //     store.dispatch({ type: types.TOGGLE_DIALOG, openModal: EModalType.JourneyTypeConfig });
        // }
    }

    componentDidUpdate(prevProps) {

        if (this.props.state.modal && prevProps.state.modal &&
            prevProps.state.modal.openModal === EModalType.None && this.props.state.modal.openModal !== EModalType.None) {

            DOMHelper.setDialogHeight();

        }

    }

    public render() {
        let { showBlockContent, changeShowBlockContent, showBlockTabs, changeShowBlockTabs, componentId,
            addOnly, toggleDecisionConfigDialog, overviewOnly } = this.props;

        let { openModal, errorMessages, warningMessages, errorMessageDismissed, overlayMessage } = this.props.state.modal;
        let childElement: JSX.Element;
        let title: string = '';

        switch (openModal) {

            case EModalType.None:
                break;

            case EModalType.ControlConfig:
                const { showBlockContent, changeShowBlockContent, changeShowNewBlock, isNewBlock, controls, changeCurrentControlIndex, addNewLayoutPanel } = this.props;

                let control = this.props.state.controlConfig.control;
                title = 'Control: ' + control && control.ControlType ? control.ControlType.NameType : '';
                childElement = <ControlConfigContainer
                    showBlockContent={showBlockContent}
                    showBlockTabs={showBlockTabs}
                    changeShowBlockContent={changeShowBlockContent}
                    changeShowBlockTabs={changeShowBlockTabs}
                    changeShowNewBlock={changeShowNewBlock}
                    changeCurrentControlIndex={changeCurrentControlIndex}
                    isNewBlock={isNewBlock}
                    controls={controls}
                    addNewLayoutPanel={addNewLayoutPanel}
                    componentId={componentId}
                />;
                break;

            case EModalType.ActionConfig:
                let actionState = this.props.state.actionConfig;
                title = actionState.loadingTemplate ? `Loading ${actionState.loadingTemplate}` : (actionState.action && actionState.action.ActionType ? actionState.action.ActionType.NameType : '');
                childElement = <ActionConfigContainer />;
                break;

            case EModalType.DecisionConfig:
                title = 'Decision';
                // addOnly ?
                //     childElement = <DecisionConfigContainer addOnly={addOnly} componentId={componentId} />
                //     :
                //     childElement = <DecisionConfigContainer componentId={componentId} />;
                childElement = <DecisionConfigContainer
                    toggleDecisionConfigDialog={toggleDecisionConfigDialog}
                    componentId={componentId}
                    dismissDialog={this.dismissDialog}
                    overviewOnly={overviewOnly} />;
                // childElement = null;
                break;

            case EModalType.SubmissionConfig:
                title = 'Submission';
                childElement = <SubmissionConfigContainer />;
                break;

            case EModalType.JourneyTypeConfig:
                title = 'Journey type';
                childElement = <JourneyTypeContainer />;
                break;

            case EModalType.GlobalOutputs:
                title = 'Global outputs';
                childElement = <OutputsDialogContainer />;
                break;

            case EModalType.Summary:
                title = 'Journey summary';
                childElement = <SummaryDialogContainer />;
                break;

            case EModalType.SaveAs:
                title = 'Save Journey As';
                childElement = <SaveAsContainer />;
                break;

            case EModalType.SharedJourneyConfig:
                title = 'Configure Shared Journey';
                childElement = <SharedJourneyConfigContainer />;
                break;

            case EModalType.RedirectConfig:
                title = 'Configure Redirect';
                childElement = <RedirectConfigContainer />;
                break;

            case EModalType.ControlBlockLooping:
                title = 'Control Block Looping';
                childElement = <ControlBlockConfigContainer />;
                break;

            case EModalType.AuthenticationWarning:
                title = 'Authentication Warning';
                childElement = <AuthenticationWarningContainer />;
                break;

            case EModalType.Blank:
                title = '';
                childElement = <div className="modal-blank-content"></div>;
                break;

            case EModalType.LoopConfig:
                title = 'Loop Configuration';
                childElement = <LoopConfigContainer />
                // childElement = <div>This is LoopConfig.s</div>
                break;
            case EModalType.AddComponent:
                title = 'Add New Component';
                childElement = <AddComponentContainer />
                break;

            default:
                break;

        }
        // return null;

        return <Cascade title={title}
            isOpen={openModal !== EModalType.None}
            onDismiss={openModal === EModalType.AuthenticationWarning ? null : this.dismissDialog}
            errorMessages={errorMessageDismissed ? [] : errorMessages}
            warningMessages={errorMessageDismissed ? [] : warningMessages}
            overlayMessage={overlayMessage}
            dismissErrorMessage={this.dismissErrorMessage}
            type={openModal === EModalType.AuthenticationWarning ? DialogType.normal : null}

            // Do not block other events since TinyMCE floatpanels needs to be clickable 
            isBlocking={true}>
            {childElement}
        </Cascade>;
    }


}

const mapStateToProps = (store) => {
    return {
        state: store.modalState,
        outputs: store.outputsState.globalOutputs
    };
};

export default connect<any, any, any>(mapStateToProps)(CascadeContainer);


// WEBPACK FOOTER //
// ./source/ts/containers/cascade.tsx